var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector selector-order-by"},[_c('div',[_c('ul',{ref:"list"},_vm._l((_vm.orderBy.data),function(o){return _c('li',{key:o.id,class:{active: o.id == _vm.orderBy.activeId},on:{"click":function($event){$event.preventDefault();return _vm.update(o.id)}}},[_c('a',{attrs:{"href":"#0"}},[_c('span',[_vm._v(_vm._s(o.name))])])])}),0)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0607fa90","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/OrderBySelector.vue
// module id = 489
// module chunks = 0